import { defineView } from "eddev/views"
import { ContentBlocks } from "eddev/blocks"
import { useRoute } from "eddev/routing"
import { Breadcrumbs } from "@components/atoms/Breadcrumbs"
import { twMerge } from "tailwind-merge"

export default defineView("page", (props) => {
  const route = useRoute()
  return (
    <>
      {route.pathname && props.page?.pageOptions?.showBreadcrumbs && (
        <Breadcrumbs uri={route.pathname} page={props.page} />
      )}
      <ContentBlocks
        blocks={props.page?.contentBlocks}
        wrapBlock={(block, ctx) => {
          const wide = block?.props?.block?.innerHTML?.includes("is-style-wide") ? true : false
          if (ctx.current.blockName.includes("core"))
            return (
              <div className="grid-auto">
                <div
                  className={twMerge(
                    "col-span-12",
                    !wide && "md:col-span-10 lg:col-span-8 md:col-start-2 lg:col-start-3",
                  )}
                >
                  {block}
                </div>
              </div>
            )

          return <>{block}</>
        }}
      />
    </>
  )
})
